import React, { useState, useEffect, useRef } from "react";

// @material-ui
import { makeStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import { Check } from "components/MaterialSymbol/MaterialIcons";
import { Assignment } from "components/MaterialSymbol/MaterialIcons";
import { Search as SearchIcon } from "components/MaterialSymbol/MaterialIcons";
import { Edit as EditIcon } from "components/MaterialSymbol/MaterialIcons";
import { Send as SendIcon } from "components/MaterialSymbol/MaterialIcons";

// core components
import ButtonMUI from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import Notification from "components/Notification/Notification.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import ReactTable from "components/ReactTable/ReactTable.js";
import AreYouSure from "components/AreYouSure/AreYouSure";
import Modal from "components/BasicDialog/BasicDialog";
import OrderStatus from "components/OrderStatus/OrderStatus";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import useUser from "hooks/useUser";
import MaterialSymbol from "components/MaterialSymbol/MaterialSymbol";

//libs
import memoize from "fast-memoize";

//service
import OrderService from "../../services/OrderService";
import CustomerService from "../../services/CustomerService";
import DealerService from "../../services/DealerService";
import PrintOrder from "components/PrintOrder/PrintOrder";
import EditOrder from "components/EditOrderNew/EditOrder";
import { formatDate, financial } from "helpers";

export const CREATE_ORDER = {
    title: "Create order",
    successMessage: "Order created successfully",
};

export const EDIT_ORDER = {
    title: "Edit order",
    successMessage: "Order updated successfully",
};

export const MOVE_ORDER = {
    title: "Edit order",
    successMessage: "Orders moved successfully",
};

import styles from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import MessageButton from "components/MessageButton/MessageButton";
import DeleteButton from "components/DeleteButton/DeleteButton";
import FormattedDate from "components/FormattedDate/FormattedDate";
import { Link, Typography } from "@material-ui/core";
import { check } from "prettier";
import useOrderFilters from "hooks/useOrderFilters";
const useStyles = makeStyles(styles);

const NEW_ORDERS = 1;

export default function Orders({ orderStatusId = NEW_ORDERS, dealerId = null, ...otherProps }) {
    const classes = useStyles();
    const [user] = useUser();
    const [statusId, setStatusId] = useState(orderStatusId);
    const [selected, setSelected] = useState([]);
    const [dlid, setDlid] = useState(0);
    const [cid, setCid] = useState(0);
    //const [dealers, setDealers] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [open, setOpen] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [newStatusId, setNewStatusId] = useState(0);
    const [search, setSearch] = useState("");
    const [orders, setOrders] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const fetchIdRef = useRef(0);
    const [notification, setNotification] = useState({
        open: false,
        message: CREATE_ORDER.successMessage,
    });
    const [modal, setModal] = useState({
        open: false,
        title: CREATE_ORDER.title,
    });
    const [initialValues, setInitialValues] = useState({});
    const [form, setForm] = useState(CREATE_ORDER);
    const [checked, setChecked] = useState(false);
    const { dealers = [], dealersIsLoading } = useOrderFilters();
    const [dealersVerified, setDealersVerified] = useState(false);

    useEffect(() => {
        if (!dealersIsLoading) {
            if (dealers.length === 1) {
                setDlid(dealers[0]?.id);
            }
            setDealersVerified(true);
        }
    }, [dealers, dealersIsLoading]);

    useEffect(() => {
        if (dealerId && dlid === 0) {
            setDlid(dealerId);
        }
    }, [dealersVerified, dealerId, dlid]);

    useEffect(() => {
        const getCustomers = async (dlid) => {
            const customers = await CustomerService.getAll(dlid, "", 0, 10000000n).then(
                (o) => o.data,
            );
            setCustomers(customers.data);
        };

        if (dealersVerified) {
            getCustomers(dlid);
        }
    }, [dealersVerified, dlid]);

    const getOrder = async (id) => {
        const order = await OrderService.get(id);
        return order;
    };

    const columns = [
        {
            Header: () => (
                <div
                    style={{
                        textAlign: "center",
                        fontSize: 15,
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <Typography style={{ fontSize: 16 }}>Select All</Typography>
                    <Checkbox
                        tabIndex={-1}
                        checked={checked}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            if (checked) {
                                setSelected([]);
                            } else {
                                setSelected(orders.map((o) => o.id));
                            }
                            setChecked(!checked);
                        }}
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        classes={{
                            checked: classes.checked,
                            root: classes.checkRoot,
                        }}
                    />
                    {/*<Link
                        href="javascript:void(0)"
                        onClick={(e) => {
                            e.preventDefault();
                            setSelected(orders.map((o) => o.id));
                        }}
                        variant="body2"
                        style={{ marginRight: 2 }}
                    >
                        Select All
                    </Link>*/}
                    {/*<Link
                        href="javascript:void(0)"
                        onClick={() => setSelected([])}
                        variant="body2"
                        style={{ marginLeft: 2, marginRight: 2 }}
                        disabled
                    >
                        Unselect
                    </Link>*/}
                </div>
            ),
            accessor: "isChecked",
            Cell: ({ row: { original } }) => {
                return (
                    <>
                        <div style={{ textAlign: "center" }}>
                            <Checkbox
                                tabIndex={-1}
                                checked={selected.includes(original.id)}
                                onClick={(e) => {
                                    if (selected.includes(original.id)) {
                                        setSelected(selected.filter((s) => s != original.id));
                                    } else {
                                        setSelected([...selected, original.id]);
                                    }
                                }}
                                checkedIcon={<Check className={classes.checkedIcon} />}
                                icon={<Check className={classes.uncheckedIcon} />}
                                classes={{
                                    checked: classes.checked,
                                    root: classes.checkRoot,
                                }}
                            />
                        </div>
                    </>
                );
            },
        },
        {
            Header: "Order number",
            accessor: "orderNumber",
        },
        {
            Header: "Name",
            accessor: "billCompany",
        },
        /*{
            Header: "Total",
            Cell: ({
                row: {
                    original: { orderAmount = 0 },
                },
            }) => {
                return `$${financial(orderAmount)}`;
            },
        },*/
        {
            Header: "Total (USD $)",
            accessor: "total_usd",
            Cell: ({
                row: {
                    original: {
                        subtotal = 0,
                        shippingAmount = 0,
                        fixedShipping = 0,
                        salesTaxAmount = 0,
                        handlingFeeAmount = 0,
                        customFeeAmount = 0,
                        currencySymbol,
                    },
                },
            }) => {
                const total =
                    (subtotal || 0) +
                    (shippingAmount || 0) +
                    (fixedShipping || 0) +
                    (salesTaxAmount || 0) +
                    (handlingFeeAmount || 0) +
                    (customFeeAmount || 0);
                return currencySymbol === "USD" ? `USD $${financial(total)}` : "";
            },
        },
        {
            Header: "Total (CAN $)",
            accessor: "total_can",
            Cell: ({
                row: {
                    original: {
                        subtotal = 0,
                        shippingAmount = 0,
                        fixedShipping = 0,
                        salesTaxAmount = 0,
                        handlingFeeAmount = 0,
                        customFeeAmount = 0,
                        currencySymbol,
                    },
                },
            }) => {
                const total =
                    (subtotal || 0) +
                    (shippingAmount || 0) +
                    (fixedShipping || 0) +
                    (salesTaxAmount || 0) +
                    (handlingFeeAmount || 0) +
                    (customFeeAmount || 0);
                return currencySymbol === "CAN" ? `CAN $${financial(total)}` : "";
            },
        },
        {
            Header: "Sent To",
            accessor: "shipCompany",
        },
        {
            Header: "Date",
            Cell: ({
                row: {
                    original: { createdAt },
                },
            }) => {
                return <FormattedDate date={createdAt} />;
                return `${formatDate(createdAt)}`;
            },
        },
        {
            Header: () => <div style={{ textAlign: "center" }}>Payment</div>,
            accessor: "payment",
            Cell: ({
                row: {
                    original: { pay_terms },
                },
            }) => {
                return <div style={{ textAlign: "center" }}>{pay_terms}</div>;
            },
        },
        {
            Header: () => <div style={{ textAlign: "center" }}></div>,
            accessor: "actions",
            Cell: ({ row: { original } }) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        {original.id && (
                            <PrintOrder dealerId={original.dealerId} id={original.id} />
                        )}
                        <Button
                            justIcon
                            round
                            simple
                            color="warning"
                            className="edit"
                            title="Edit order products"
                            onClick={async () => {
                                setForm(EDIT_ORDER);

                                const order = await getOrder(original.id);

                                console.log("order for edit:", order);

                                setInitialValues({
                                    ...order,
                                    details: order.details.map((od) => {
                                        const qtyDifference =
                                            parseInt(od.qty) - parseInt(od.shipQty);

                                        return {
                                            ...od,
                                            qtyShipped: od.shipQty,
                                            shipQty: !od.shipQty ? "" : qtyDifference,
                                        };
                                    }),
                                });
                                setModal({
                                    ...modal,
                                    open: !modal.open,
                                });
                            }}
                        >
                            <EditIcon />
                        </Button>
                        {/*<MessageButton orderNumber={original.orderNumber} />*/}
                        {/*<Button
                            justIcon
                            round
                            simple
                            color="danger"
                            className="edit"
                            title="Delete"
                            onClick={() => {
                                setInitialValues(original);
                                setOpen(true);
                            }}
                        >
                            <Close />
                        </Button>*/}
                    </div>
                );
            },
        },
    ];

    const fetchData = React.useCallback(
        memoize(
            (fromDate, toDate, statusId, search, cid, dlid) => async ({ pageSize, pageIndex }) => {
                if (!dealersVerified) return;

                const fetchId = ++fetchIdRef.current;

                if (fetchId === fetchIdRef.current) {
                    const startRow = pageSize * pageIndex;

                    const orders = await OrderService.getAll(
                        startRow,
                        pageSize,
                        fromDate ? formatDate(fromDate) : "",
                        toDate ? formatDate(toDate) : "",
                        statusId,
                        search,
                        cid,
                        dlid,
                    ).then((x) => x.data);
                    setOrders(orders?.data || []);
                    setPageCount(Math.ceil(orders.recordsTotal / pageSize));
                }
            },
        ),
        [dealersVerified],
    );

    const onSuccess = async (order) => {
        if (form === CREATE_ORDER) {
            setOrders([order, ...orders]);
        }

        if (form === EDIT_ORDER) {
            const nOrders = orders.map((c) => (c.id === order.id ? { ...c, ...order } : c));
            setOrders(nOrders);
        }

        setInitialValues({});
        setModal({ ...modal, open: !modal.open });
        setNotification({
            ...notification,
            open: true,
            message: form.successMessage,
        });
    };

    return (
        <>
            <AreYouSure
                open={open}
                title={`Are you sure you?`}
                subtitle={``}
                onAccept={async () => {
                    await OrderService.putOrderStatus(selected, newStatusId);
                    setOrders([...orders].filter((o) => !selected.includes(o.id)));
                    setOpen(false);
                    setSelected([]);
                    setNewStatusId(0);
                    setNotification({
                        open: true,
                        message: MOVE_ORDER.successMessage,
                    });
                }}
                onCancel={() => setOpen(false)}
            />

            {notification.open && (
                <Notification
                    open={notification.open}
                    message={notification.message}
                    close
                    color="success"
                    onClose={(e) => setNotification({ ...notification, open: false })}
                />
            )}

            <Modal
                fullWidth
                maxWidth="xl"
                open={modal.open}
                title={form.title}
                onClose={() => {
                    setModal({ ...modal, open: false });
                }}
                PaperProps={{
                    style: {
                        backgroundColor: "transparent",
                        boxShadow: "none",
                    },
                }}
            >
                {modal.open ? (
                    <EditOrder form={form} order={initialValues} onSuccess={onSuccess} />
                ) : null}
            </Modal>

            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader
                            color="primary"
                            icon
                            style={{ display: "flex", alignItems: "center" }}
                        >
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                            <Button
                                color="primary"
                                onClick={() => {
                                    setForm(CREATE_ORDER);
                                    setInitialValues({});
                                    setModal({ ...modal, open: true });
                                }}
                            >
                                Create order
                            </Button>
                        </CardHeader>
                        <CardBody>
                            <div style={{ marginBottom: 10 }}>
                                <GridContainer>
                                    {user?.isAdmin === 1 && (
                                        <GridItem
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            style={{ display: dealerId ? "none" : "block" }}
                                        >
                                            <FormControl variant="standard" fullWidth>
                                                <InputLabel id="demo-simple-select-label">
                                                    Dealer
                                                </InputLabel>
                                                <Select
                                                    id="dealerId"
                                                    name="dealerId"
                                                    value={dlid}
                                                    onChange={(e) => {
                                                        setDlid(e.target.value);
                                                        setCid(0);
                                                    }}
                                                    fullWidth
                                                >
                                                    {dealers.length > 1 && (
                                                        <MenuItem key={0} value={0}>
                                                            All dealers
                                                        </MenuItem>
                                                    )}
                                                    {dealers.map((dealer, index) => (
                                                        <MenuItem key={index} value={dealer.id}>
                                                            {dealer.id}. {dealer.company}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </GridItem>
                                    )}
                                    <GridItem xs={12} sm={12} md={2}>
                                        <FormControl variant="standard" fullWidth>
                                            <InputLabel id="demo-simple-select-label">
                                                Customers
                                            </InputLabel>
                                            <Select
                                                id="dealerId"
                                                name="dealerId"
                                                value={cid}
                                                onChange={(e) => {
                                                    setCid(e.target.value);
                                                }}
                                                fullWidth
                                            >
                                                <MenuItem key={0} value={0}>
                                                    Select customer
                                                </MenuItem>

                                                {customers.map((customer, index) => (
                                                    <MenuItem key={index} value={customer.id}>
                                                        {customer.billCompany}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={2}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker
                                                id="date-picker-dialog"
                                                label="From date"
                                                format="MM/dd/yyyy"
                                                value={fromDate}
                                                onChange={(value) => setFromDate(value)}
                                                KeyboardButtonProps={{
                                                    "aria-label": "change date",
                                                }}
                                                keyboardIcon={<MaterialSymbol>calendar_today</MaterialSymbol>}
                                                fullWidth
                                            />
                                        </MuiPickersUtilsProvider>
                                    </GridItem>
                                    <GridItem xs={12} sm={2}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker
                                                id="date-picker-dialog"
                                                label="To date"
                                                format="MM/dd/yyyy"
                                                value={toDate}
                                                onChange={(value) => setToDate(value)}
                                                KeyboardButtonProps={{
                                                    "aria-label": "change date",
                                                }}
                                                keyboardIcon={<MaterialSymbol>calendar_today</MaterialSymbol>}
                                                fullWidth
                                            />
                                        </MuiPickersUtilsProvider>
                                    </GridItem>
                                    <GridItem xs={12} sm={2}>
                                        <OrderStatus
                                            statusId={statusId}
                                            onChange={(value) => setStatusId(value)}
                                        />
                                    </GridItem>
                                    <GridItem xs={12} sm={2}>
                                        <TextField
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                            label="Search String"
                                            helperText="[Name, Order# etc]"
                                            fullWidth
                                        />
                                    </GridItem>
                                    <GridItem xs={12} sm={2} style={{ display: "none" }}>
                                        <Button
                                            color="success"
                                            variant="contained"
                                            startIcon={<SearchIcon />}
                                            onClick={() => {
                                                console.log(fromDate, toDate, status, search);
                                            }}
                                        >
                                            Search
                                        </Button>
                                    </GridItem>
                                </GridContainer>
                                {selected.length > -1 && (
                                    <GridContainer
                                        className="orders-bulk-action-row"
                                        style={{ marginBottom: 10 }}
                                    >
                                        <GridItem
                                            xs={12}
                                            sm={8}
                                            className="orders-bulk-action-left"
                                        >
                                            <div style={{ minWidth: 240 }}>
                                                <OrderStatus
                                                    showAll={false}
                                                    label="Update Order Status"
                                                    onChange={(value) => setNewStatusId(value)}
                                                />
                                            </div>
                                            <DeleteButton
                                                disabled={newStatusId === 0 || selected.length === 0}
                                                variant="contained"
                                                buttonWithIcon
                                                startIcon={<SendIcon />}
                                                buttonLabel="Apply"
                                                className="orders-bulk-action-button"
                                                customTitle="Confirm Order Status?"
                                                customSubTitle="This will change the current order status."
                                                confirmationBtnTitle="Save"
                                                handleClick={async () => {
                                                    await OrderService.putOrderStatus(
                                                        selected,
                                                        newStatusId,
                                                    );
                                                    setOrders(
                                                        [...orders].filter(
                                                            (o) => !selected.includes(o.id),
                                                        ),
                                                    );
                                                    setOpen(false);
                                                    setSelected([]);
                                                    setNewStatusId(0);
                                                    setNotification({
                                                        open: true,
                                                        message: MOVE_ORDER.successMessage,
                                                    });
                                                }}
                                                style={{
                                                    backgroundColor:
                                                        newStatusId !== 0 && selected.length !== 0
                                                            ? "#111827"
                                                            : undefined,
                                                }}
                                            />
                                        </GridItem>
                                        <GridItem
                                            xs={12}
                                            sm={4}
                                            className="orders-bulk-action-right"
                                        >
                                            <ButtonMUI
                                                color="primary"
                                                variant="contained"
                                                className="orders-bulk-action-button"
                                                onClick={() => {
                                                    if (user?.isAdmin === 1) {
                                                        setDlid(0);
                                                    } else {
                                                        setDlid(dlid || dealerId);
                                                    }
                                                    setCid(0);
                                                    setFromDate(null);
                                                    setToDate(null);
                                                    setStatusId(1);
                                                    setSearch("");
                                                }}
                                                style={{
                                                    backgroundColor: "#111827",
                                                    color: "#ffffff",
                                                    boxShadow: "none",
                                                }}
                                            >
                                                Clear filters
                                            </ButtonMUI>
                                        </GridItem>
                                    </GridContainer>
                                )}
                            </div>

                            <GridContainer>
                                <GridItem xs={12} sm={12}>
                                    <ReactTable
                                        columns={columns}
                                        data={orders}
                                        fetchData={fetchData(
                                            fromDate,
                                            toDate,
                                            statusId,
                                            search,
                                            cid,
                                            dlid,
                                        )}
                                        pageCount={pageCount}
                                        manualPagination={true}
                                        showSorting={false}
                                    />
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        </>
    );
}
